module.exports = __webpack_public_path__ + "static/media/school.34bc95ef.svg";